import React from 'react';
import { createUseStyles } from 'react-jss';

function MzLabel({text,style, className}) {
const st=styles();
  return (
    <div style={style}  className={className+" "+st.container}>{text}</div>
  );
}

const styles = createUseStyles({
  container: {
    fontFamily: "var(--font-family)",
    fontFeatureSettings: "var(--font-feature-settings, normal)",
    fontSize:"1rem",
    color: "#495057",
    fontWeight:"700"
    
  }
});

export default MzLabel;